import { UseQueryResult, useQuery } from 'react-query'
import request from '../../request'
import { useBuildQueryParams } from '../../../lib/hooks/useBuildQueryParams'
import { useDealership } from '../../../store/zustand/dealershipStore'

type VendorCampaignItem = {
  vendor_campaign_name: string
  client_campaign_display_name: string
  [x: string]: string | number
}

export const useGetVendorCampaignsList = ({
  filters,
}: {
  filters?: Record<string, unknown>
}): UseQueryResult<Array<VendorCampaignItem>, Error> => {
  const dealership = useDealership()
  const queryParams = useBuildQueryParams(filters)

  return useQuery<Array<VendorCampaignItem>, Error>(
    ['vendor-campaigns', 'list', { queryParams }],
    ({ signal }) =>
      request<Array<VendorCampaignItem>>({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/campaigns/vendor-campaigns/list`,
        method: 'GET',
        signal,
        params: {
          ...queryParams,
        },
      }).then((res: any) => res.data),
    {
      keepPreviousData: true,
    },
  )
}
